import { PokerCategory } from '../../../services/common/types/pokerCategory';
import { BettingStructure } from '../../../services/common/types/bettingStructure';
import { TableType } from '../../../services/common/types/tableType';

export interface StakeOptionFilter {
  bettingStructure: BettingStructure;
  min?: number;
  max?: number;
}

export interface TableFilter {
  type?: TableType;
  category?: PokerCategory;
  bettingStructure?: BettingStructure;
  fullTables?: boolean;
  emptyTables?: boolean;
  minBuyIn?: number;
  maxBuyIn?: number;
  tableName: string;
  rake?: number;
  tableFeature?: string;
  tableSize?: number;
  stakeOptions?: StakeOptionFilter[];
}

export interface GameValue {
  category: PokerCategory;
  games: GameVariants[];
  label: string;
}

export enum GameVariants {
  // Texas
  NoLimitTexasHoldem = 'NoLimitTexasHoldem',
  NoLimitShortDeckHoldem = 'NoLimitShortDeckHoldem',
  FixedLimitTexasHoldem = 'FixedLimitTexasHoldem',

  // Omaha
  PotLimitOmaha = 'PotLimitOmaha',
  PotLimitOmahaCapped = 'PotLimitOmahaCapped',
  PotLimitOmahaEightOrBetter = 'PotLimitOmahaEightOrBetter',
  FixedLimitOmahaHigh = 'FixedLimitOmahaHigh',
  FixedLimitOmahaEightOrBetter = 'FixedLimitOmahaEightOrBetter',
  PotLimitFiveCardOmaha = 'PotLimitFiveCardOmaha',
  PotLimitFiveCardOmahaEightOrBetter = 'PotLimitFiveCardOmahaEightOrBetter',
  PotLimitFiveCardOmahaCapped = 'PotLimitFiveCardOmahaCapped',
  PotLimitFiveCardOmahaEightOrBetterCapped = 'PotLimitFiveCardOmahaEightOrBetterCapped',
  NoLimitOmahaEightOrBetter = 'NoLimitOmahaEightOrBetter',
  FixedLimitFiveCardOmahaEightOrBetter = 'FixedLimitFiveCardOmahaEightOrBetter',

  // Stud
  FixedLimitSevenCardStud = 'FixedLimitSevenCardStud',
  FixedLimitStudEightOrBetter = 'FixedLimitStudEightOrBetter',
  FixedLimitStudHighLowRegular = 'FixedLimitStudHighLowRegular',
  FixedLimitRazz = 'FixedLimitRazz',
  FixedLimitDeuceToSevenRazz = 'FixedLimitDeuceToSevenRazz',

  // Draw
  FixedLimitBadugi = 'FixedLimitBadugi',
  FixedLimitBadeucy = 'FixedLimitBadeucy',
  FixedLimitBadacey = 'FixedLimitBadacey',
  FixedLimitAceToFiveLowballTripleDraw = 'FixedLimitAceToFiveLowballTripleDraw',
  FixedLimitDeuceToSevenLowballTripleDraw = 'FixedLimitDeuceToSevenLowballTripleDraw',
  FixedLimitArchieSixesHighEightOrBetter = 'FixedLimitArchieSixesHighEightOrBetter',
  FixedLimitArchieNinesHighEightOrBetter = 'FixedLimitArchieNinesHighEightOrBetter',
  FixedLimitDramahaBadugi = 'FixedLimitDramahaBadugi',
  FixedLimitDramahaHigh = 'FixedLimitDramahaHigh',
  FixedLimitDeuceToSevenDramaha = 'FixedLimitDeuceToSevenDramaha',
  NoLimitDeuceToSevenLowballSingleDraw = 'NoLimitDeuceToSevenLowballSingleDraw',
  NoLimitDeuceToSevenLowballSingleDrawCapped = 'NoLimitDeuceToSevenLowballSingleDrawCapped',
}
